import { TRatingStars } from '@/common/domain/Rating.domain';
import * as S from './ActivitySubtitle.styles';
import { useTalkToUs } from '@/shared/TalkToUs/service/TalkToUs.service';
import { ReviewsBlock } from '@/entities/Reviews/ui/ReviewBlock';
import { useChatStore } from '@/entities/Chat/ui/useChatStore';
import { ReviewsRecommended } from '@/shared/RecentReviews/ui/ReviewsRecommended';
import { AnswerLink } from '../Answers/AnswerLink';

type ActivitySubtitleProps = {
    destination: { name: string; code: string };
    scrollToReviews?: () => void;
    ratings: TRatingStars;
    rating: string;
    reviewsCount: number;
    onTalkToUsClick?: () => void;
    isGiftCard?: boolean;
    isTour?: boolean;
    oneRow?: boolean;
    hideDestination?: boolean;
    rateRecommended?: string;
};

export const ActivitySubtitle = ({
    destination,
    ratings,
    rating,
    reviewsCount,
    onTalkToUsClick,
    scrollToReviews,
    isGiftCard,
    isTour,
    oneRow,
    hideDestination,
    rateRecommended,
}: ActivitySubtitleProps) => {
    const { name, code } = destination;

    const { isValidTime } = useTalkToUs();
    const toggleChat = useChatStore((state) => state.toggleChat);

    return (
        <S.ActivitySubtitleContainer data-test-id="Activity_subtitle" oneRow={oneRow}>
            <S.LeftSection oneRow={oneRow}>
                {!isGiftCard && !hideDestination && (
                    <S.Location>
                        <S.LocationIcon />
                        {`${name}, ${code}`}
                    </S.Location>
                )}
                {!isGiftCard && (
                    <>
                        <ReviewsBlock
                            ratingStars={ratings}
                            rating={rating}
                            rateCount={reviewsCount}
                            onClick={scrollToReviews}
                            size="medium"
                            emptyReviewsMsg=""
                            tooltip="Once your trip is completed, you can tell us about your experience"
                        />
                    </>
                )}
                <ReviewsRecommended rateRecommended={rateRecommended} reviewsCount={reviewsCount} />
                {!oneRow && <AnswerLink />}
            </S.LeftSection>
            {!!onTalkToUsClick && (
                <S.RightSection>
                    {isTour ? (
                        <S.TalkToUsLink
                            onClick={(e) => {
                                if (!isValidTime()) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    onTalkToUsClick?.();
                                }
                            }}
                            data-test-id="Talktous_button"
                            href="tel:+18504245125"
                        >
                            <S.TalkToUsIcon />
                            &nbsp; 850-424-5125
                        </S.TalkToUsLink>
                    ) : (
                        <S.ButtonsWrapper>
                            <S.TalkToUsButton
                                variant="transparent"
                                onClick={toggleChat}
                                data-test-id="Talktous_button"
                            >
                                <S.ChatWithUsIcon />
                                <S.ButtonText>&nbsp; Chat with us</S.ButtonText>
                            </S.TalkToUsButton>
                            <S.TalkToUsButton
                                variant="transparent"
                                onClick={() => onTalkToUsClick?.()}
                                data-test-id="Talktous_button"
                            >
                                <S.TalkToUsIcon />
                                <S.ButtonText>&nbsp; Talk to us</S.ButtonText>
                            </S.TalkToUsButton>
                        </S.ButtonsWrapper>
                    )}
                </S.RightSection>
            )}
        </S.ActivitySubtitleContainer>
    );
};
